import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import reactStringReplace from 'react-string-replace';
import { useLocalI18n } from '../../../data/hooks/i18nHooks';
import edgeIcon from '../icons/edge.png';
import strings from '../strings.i18n.csv';
import styles from './EdgeUpgradeNotice.module.scss';
import { suggestUpgrade } from './suggestUpgrade';

const EdgeUpgradeNotice = (props) => {
    const [dismissed, setDismissed] = useState(false),
        [expanded, setExpanded] = useState(false),
        i18n = useLocalI18n(strings),
        description = reactStringReplace(
            i18n['edge_upgrade'],
            /\[(.*)\]/,
            (match, i) => (
                <a
                    key={i}
                    href='https://www.microsoft.com/en-us/edge'
                    target='_blank'
                    rel='noopener noreferrer'>
                    {match}
                </a>
            )
        );

    if (!suggestUpgrade()) return null;
    if (dismissed) return null;

    function handleDismiss(e) {
        setDismissed(true);
    }

    function handleReadMore() {
        setExpanded(true);
    }

    return (
        <div className={styles.EdgeUpgradeNotice}>
            <img src={edgeIcon} />
            <div className={[styles.label, 'VerticalCenter'].join(' ')}>
                <p>{i18n['edge_short']}</p>
                {expanded ? (
                    <>
                        <br />
                        <p>{description}</p>
                        <br />
                        <p>{i18n['citrix_warning']}</p>
                    </>
                ) : (
                    <a
                        href='#'
                        className={styles.readMore}
                        onClick={handleReadMore}>
                        {i18n['edge_read_more']}
                    </a>
                )}
            </div>
            <button
                type='button'
                className={styles.dismiss}
                onClick={handleDismiss}>
                <FontAwesomeIcon icon={faXmark} />
            </button>
        </div>
    );
};

export default EdgeUpgradeNotice;
